
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publications",
      function () {
        return require("private-next-pages/publications.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publications"])
      });
    }
  